import styled from 'styled-components';

export const ContainerMissionCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  background-color: ${({ theme }) => theme?.colors?.theme?.contentBg};
  border-radius: 16px;
  width: 100%;
  min-width: 360px;
  height: 136px;
  box-shadow: -2px 2px 2px 0px rgba(10, 20, 26, 0.30);
  overflow: hidden;
  cursor: pointer;
  @media (max-width: 768px) {
    width: auto;
    min-width: unset;
  }
`;

export const CardStatusIcon = styled.div<{ status?: 'active' | 'inactive' | 'success' | 'expired' }>`
  width: auto;
  height: 300px;
  margin-right: 8px;
  border-radius: 8px;
  display: inline-block;
  svg {
    width: 24px;
    height: 24px;
    color: ${(props) => {
      switch (props.status) {
        case 'active':
          return `${props.theme?.colors?.theme?.brandColor3}`;
        case 'inactive':
          return `${props.theme?.colors?.theme?.warning}`;
        case 'success':
          return `${props.theme?.colors?.theme?.success}`;
        case 'expired':
          return `${props.theme?.colors?.text?.neutral}`;
        default:
          return `${props.theme?.colors?.text?.neutral}`;
      }
    }};
  }
`;

export const SocialMediaIcon = styled.img<{ $isDark?: boolean }>`
  width: auto;
  height: auto;
  margin-right: 8px;
  border-radius: 8px;
  filter: ${({ $isDark }) => $isDark ? 'brightness(1)' : 'brightness(0)'};
`;

export const ContainerStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
`;

export const ContainerStatusInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 24px;
  padding: 8px 12px;
`;

export const ContentTextClaimBenefit = styled.p`
  color:  ${({ theme }) => theme?.colors?.common?.yellow};
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${({ theme }) => theme?.colors?.text?.muted};
  margin: 0 8px;
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
